<style lang="css" scoped>

.main {
    border: 1px solid rgba(25, 118, 210, 0.3);
}

.header {
    border-bottom: 1px solid rgba(25, 118, 210, 0.3);
    background-color: rgba(25,118,210,0.1);
}

</style>

<template>

<v-layout row wrap class="mx-auto main mb-3">
    <v-flex xs12 class="text-xs-center pa-3 header">
        <v-icon color="blue darken-4">date_range</v-icon>
        <h3 class="mx-auto">{{content.schedule}}</h3>
    </v-flex>
    <v-flex xs12>
        <v-layout column v-if="schedules && Object.keys(schedules).length">
            <v-flex xs12 v-for="(sched, index) in schedules" :key='index' class="schedule">
                <v-layout row nowrap align-center class="px-3 py-2">
                    <v-layout column>
                        <v-flex v-if="sched.days.length < 7">
                            <span v-for="(day, dKey) in sched.days" :key='dKey'>
                              {{days[day]}}
                              <span shrink v-if="dKey+1 != sched.days.length">, </span>
                            </span>
                        </v-flex>
                        <v-flex v-else>
                            <span>{{content.all_days}}</span>
                        </v-flex>
                        <v-divider style="max-width:250px;"></v-divider>
                        <v-flex class="mt-1">
                            {{sched.start_at}} - {{sched.end_at}}
                        </v-flex>
                    </v-layout>
                    <v-flex shrink>
                        <v-btn flat icon color="light-blue" @click="openDialog(sched, index)">
                            <v-icon>edit</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-divider></v-divider>
            </v-flex>
        </v-layout>
        <v-layout row wrap v-else>
          <v-flex xs12>
            <div class="text-xs-center pa-2">
              {{content.empty}}
            </div>
          </v-flex>
        </v-layout>
    </v-flex>

    <v-flex xs12>
        <v-btn color="info" dark class="mb-0 mt-2" block @click="openDialog()">{{content.new_schedule}}</v-btn>
    </v-flex>

    <schedialog :locale="locale" :status="dialog" :data="dialogData" @modifyScheduleEvent="modify"></schedialog>
</v-layout>

</template>

<script>

import { mapGetters } from 'vuex'
import Schedialog from './edit/scheduleDialog'
export default {
    props: ['locale', 'action'],
    components: { Schedialog },
    data() {
        return {
            schedules: null,
            dialog: false,
            dialogData: null,
            modifiedSched: null,
            edit: false,
        }
    },
    created() {
        this.setLang();
        this.schedules = this.data;
        this.analyze();
        // EventBus.$on('updateItemsBus', data => {
        //   this.schedules = data.items[];
        //   this.analyze();
        //   if (this.edit) {
        //     this.edit = false;
        //     this.clear();
        //   }
        // });
    },
    computed: {
       ...mapGetters(['devices/device']),
      data: function (getter) {
        this.loading = null
        return getter['devices/device'](this.$route.params.slug).data.schedule;
      }
    },
    watch: {
        data() {
          this.schedules = this.data;
          if (this.schedules) {
            this.analyze();
            if (this.edit) {
              this.edit = false;
              this.clear();
            }
          }
        },
        action() {
          if (this.action == 1) {
            this.openDialog();
          } else if (this.action == 2) {
            this.modifySchedule([{
                days: [1,2,3,4,5,6,7],
                start_at: '00:00',
                end_at: '23:59',
            }])
          }
        }
    },
    methods: {
        analyze() {
            for (let i = 0; i < this.schedules.length; i++) {
                if (!isNaN(this.schedules[i].start_at)) {
                    this.schedules[i].start_at = this.getTimeByMins(this.schedules[i].start_at);
                }
                if (!isNaN(this.schedules[i].end_at)) {
                    this.schedules[i].end_at = this.getTimeByMins(this.schedules[i].end_at);
                }
            }
        },
        getTimeByMins(mins) {
            return `0${mins / 60 ^ 0}`.slice(-2) + ':' + ('0' + mins % 60).slice(-2);
        },

        modify(sched){
          let schedule = this.schedules;
          if (sched.delete) {
            delete schedule[this.modifiedSched];
            schedule = schedule.filter(function(e){return e});
          } else if (this.modifiedSched != null) {
            schedule[this.modifiedSched] = sched;
          } else {
            schedule.push(sched);
          }
          // console.log(schedule);
          this.modifySchedule(schedule);
        },
        modifySchedule(schedule) {
            let data = {
                slug: this.$route.params.slug,
                modify: {
                    parameter: 'schedule',
                    value: schedule,
                }
            }
            this.edit = this.$route.params.slug;
            this.$store.dispatch('devices/modifyDevice', data);
            // this.$emit('modifyItemEvent', data);
        },

        openDialog(sched = null, index = null){
          this.dialog += 1;
          this.dialogData = sched;
          this.modifiedSched = index;
        },
        clear() {
          this.dialog = false;
        },

        setLang() {
            if (this.locale == "en") {
                this.days = [null, 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
                this.daysOptions = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                this.content = {
                    schedule: 'Schedule',
                    new_schedule: 'New Schedule',
                    all_days: 'All Days',
                    edit: 'Edit Schedule',
                    agree: 'Agree',
                    save: 'Save',
                    cancel: 'Cancel',
                    start_at: 'Start at',
                    end_at: 'End at',
                    days: 'Days',
                    delete: 'Delete',
                    ask_delete: 'Are you sure you would like to delete?',
                    yes: 'Yes',
                    no: 'No',
                    empty: 'Empty Schedule',
                };

            } else if (this.locale == "he") {
                this.days = [null, 'ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
                this.daysOptions = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
                this.content = {
                    schedule: 'לוח זמנים',
                    new_schedule: 'תזמון חדש',
                    all_days: 'כל הימים',
                    edit: 'עריכת תזמון',
                    agree: 'מסכים',
                    save: 'שמירה',
                    cancel: 'ביטול',
                    start_at: 'מתחיל ב-',
                    end_at: 'נגמר ב-',
                    days: 'ימים',
                    delete: 'מחיקה',
                    ask_delete: 'אתה בטוח שברצונך למחוק?',
                    yes: 'כן',
                    no: 'לא',
                    empty: 'לוח זמנים ריק',
                };
            }
        },
    }
}

</script>
